import styled from 'styled-components/macro';

function getMiddleBoxMargins(props) {
  if (props.marginTop) {
    return props.marginTop;
  }

  return '0px';
}

export const LoadingHolder = styled.div`
  z-index: 1;
  display: ${(props) => (props.hide ? 'none' : 'flex')};
  flex: 1;
  /* height: -webkit-fill-available; */
`;

export const MiddleBox = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-top: ${(props) => getMiddleBoxMargins(props)};
`;

export const LoadingText = styled.div`
  margin-top: 20px;
  font-size: 14px;
  color: var(--base-text);
`;
